/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     ChangePassword
//   Details:    Change Password page
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 108946 27/07/20 JC  M01  Pass current password when changing existing
// 109897 18/09/20 JC  M02  Hide current password if User.isForgottenPassword
//-------------------------------------------------------
*/
import React, { Component } from 'react';
import { Button, FormGroup, FormControl, FormLabel, Col } from "react-bootstrap";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { passwordActions } from '../store/PasswordManager';
import Header from '../components/Header';
import Loading from '../components/Loading';
import AlertPanel from '../components/AlertPanel';

class ChangePassword extends Component {
	constructor(props) {
		super(props);

        this.state = {
            currentPassword: '', //M01
            newPassword: '', //M01
			repeatPassword: ''
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	validateForm() {
        return (this.props.passwordManager.isForgottenPassword || this.state.currentPassword.length > 0)
            && this.state.newPassword.length > 0
            && this.state.repeatPassword.length > 0; //M01 M02 don't validate current password if is forgotten password
	}

	handleChange = event => {
		this.setState({
			[event.target.id]: event.target.value
		});
	}

	handleSubmit = event => {
		event.preventDefault();
		this.props.change(this.state.currentPassword, this.state.newPassword, this.state.repeatPassword); //M01
	}

	render() {
        const { passwordManager } = this.props;

        return (
            <div>
                <Header title="Change Password" />
                {passwordManager.success ? <AlertPanel type="success" message={passwordManager.success} /> : []}
                {passwordManager.error ? <AlertPanel type="danger" message={passwordManager.error} /> : []}

                <Col sm={{ span: 6, offset: 3 }}> 
                    {passwordManager.changingPassword ? <Loading /> : []}
                    {!passwordManager.changingPassword ?

                        <form onSubmit={this.handleSubmit}>
                            {/* M01 current password M02 unless user is forgotten password  */
                                !passwordManager.isForgottenPassword ?
                                <FormGroup controlId="currentPassword" bsSize="large"> 
                                    <FormLabel>Current Password</FormLabel>
                                    <FormControl
                                        value={this.state.currentPassword}
                                        onChange={this.handleChange}
                                        type="password"
                                            />
                                        </FormGroup>
                                    : []}
                            <FormGroup controlId="newPassword" bsSize="large"> {/* M01 */}
								<FormLabel>New Password</FormLabel>
								<FormControl
                                    value={this.state.newPassword} /* M01 */
									onChange={this.handleChange}
									type="password"
								/>
							</FormGroup>
							<FormGroup controlId="repeatPassword" bsSize="large">
								<FormLabel>Repeat Password</FormLabel>
								<FormControl
									value={this.state.repeatPassword}
									onChange={this.handleChange}
									type="password"
								/>
							</FormGroup>
                  <Button
                    className="btn btn-default"
								    block
								    bsSize="large"
								    disabled={!this.validateForm()}
								    type="submit"
							    >
							Change Password
					</Button>
					</form>
					: []}
				</Col>
			</div>
		);
	}
}

export default connect(
    state => ({ passwordManager: state.passwordManager, message: state.passwordManager.message}), 
	dispatch => bindActionCreators(passwordActions, dispatch)
)(ChangePassword);